/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 20;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();
    const normalizedId = String(productId);

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== normalizedId);
    viewedProducts.unshift(normalizedId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    try {
      const rawValue = localStorage.getItem(this.#STORAGE_KEY) || '[]';
      const parsed = JSON.parse(rawValue);

      if (!Array.isArray(parsed)) return [];

      return parsed.map((id) => String(id)).filter((id) => id !== '');
    } catch {
      return [];
    }
  }
}
